import { Alert } from "@mui/material";
import React from "react";

import { MEDICALLY_COMPLETE_LOCK_MESSAGE } from "../modules/ClientDetail/Case/utils/constants";

export default function MedicalCompleteLockNotice({ locked, className = "" }) {
  if (!locked) {
    return null;
  }

  return (
    <Alert
      variant="outlined"
      severity="info"
      role="alert"
      data-test-id="medically-complete-lock-notice"
      className={className}
    >
      {MEDICALLY_COMPLETE_LOCK_MESSAGE}
    </Alert>
  );
}
